import storage from "~/services/storage"

export default defineNuxtRouteMiddleware((to, _from) => {
  if (useRuntimeConfig().public.appEnv !== "test") {
    if (to.name !== "login" && !storage.getAuthToken()) {
      storage.setLastPath(to.fullPath)
      window.location.href = "/v2/login"
    }
  }
})
